import { render, staticRenderFns } from "./CategoryListDuplicate.vue?vue&type=template&id=3c368d2f&scoped=true"
import script from "./CategoryListDuplicate.vue?vue&type=script&lang=js"
export * from "./CategoryListDuplicate.vue?vue&type=script&lang=js"
import style0 from "./CategoryListDuplicate.vue?vue&type=style&index=0&id=3c368d2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c368d2f",
  null
  
)

export default component.exports